import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "./ReviewerEvaluate.css";
import NavbarReviewer from "../Reviewer/ReviewerUI/NavbarReviewer.jsx";
import ReviewerEvaluationForm from "../../components/Reviewer/ReviewerEvaluationForm.jsx";
import { BiArrowBack } from "react-icons/bi";
import ENDPOINT_URL from "../../config";

const ReviewerEvaluate = () => {
  const navigate = useNavigate();
  const { applicationId: reviewFormId } = useParams();
  const { state } = useLocation();

  const [pdfUrl, setPdfUrl] = useState("");

  /*  START: VIEW MODE STATE ADDED  */
  const [viewMode, setViewMode] = useState("split"); // default mode
  /*  END: VIEW MODE STATE ADDED  */

  const reviewerInfo =
    JSON.parse(localStorage.getItem("reviewer_info")) || {};

  const applicantInfo = {
    name: state?.applicantName || "",
    email: state?.applicantEmail || "",
  };

  useEffect(() => {
    if (state?.applicantConceptFile) {
      setPdfUrl(state.applicantConceptFile);
    }
  }, [state]);

  const wrappedPdfUrl = pdfUrl
    ? `https://docs.google.com/gview?url=${encodeURIComponent(
        pdfUrl
      )}&embedded=true`
    : "";

  const handleEvaluationSubmit = async (formValues) => {
    try {
      const payload = {
        nameOfApplicant: formValues.applicantName,
        emailOfApplicant: formValues.applicantEmail,

        nameOfReviewer: reviewerInfo.name,
        emailOfReviewer: reviewerInfo.email,

        innovativeness: formValues.innovativenessScore,
        marketOpportunity: formValues.marketOpportunityScore,
        teamAndExpertise: formValues.teamExpertiseScore,
        iprInclusivity: formValues.iprScore,
        businessModelAndMarketStrategy: formValues.businessModelScore,

        hasSocialImpact: formValues.societalImpact === "Yes" ? 1 : 0,
        reviewFormId: reviewFormId,
        remark: formValues.remark || "",
      };

      // const res = await fetch("http://localhost:5000/api/review/form-submit", {
          const res = await fetch(`${ENDPOINT_URL}/api/review/form-submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (!res.ok) return alert("Failed to submit review");

      alert("Review submitted successfully!");
      navigate("/reviewer/pipelines/applicant");
    } catch (err) {
      alert("Something went wrong");
    }
  };

  // ======== START: RESIZABLE PANELS (Desktop only) ========
const [leftWidth, setLeftWidth] = useState(40); // percentage
const [isResizing, setIsResizing] = useState(false);

const startResizing = () => {
  if (window.innerWidth >= 1281) {
    setIsResizing(true);
  }
};

const stopResizing = () => setIsResizing(false);

const resizePanels = (e) => {
  if (!isResizing) return;

  const containerWidth = document
    .querySelector(".abc123-reviewereevaluate-container")
    .offsetWidth;

  let newLeftWidth = (e.clientX / containerWidth) * 100;

  // Min 20% and Max 70%
  if (newLeftWidth < 20) newLeftWidth = 20;
  if (newLeftWidth > 70) newLeftWidth = 70;

  setLeftWidth(newLeftWidth);
};

useEffect(() => {
  window.addEventListener("mousemove", resizePanels);
  window.addEventListener("mouseup", stopResizing);

  return () => {
    window.removeEventListener("mousemove", resizePanels);
    window.removeEventListener("mouseup", stopResizing);
  };
}, [isResizing]);
// ======== END: RESIZABLE PANELS ========

  return (
    <>
      <NavbarReviewer />

      {/* === BACK + VIEW OPTIONS ROW === */}
      <div className="abc123-reviewereevaluate-toprow">

        {/*  START: ADDED VIEW MODE BUTTONS  */}
        <div className="abc123-viewmode-btn-group">
          <button
            className={`abc123-view-btn ${viewMode === "pdf" ? "active" : ""}`}
            onClick={() => setViewMode("pdf")}
          >
            PDF View
          </button>

          <button
            className={`abc123-view-btn ${viewMode === "form" ? "active" : ""}`}
            onClick={() => setViewMode("form")}
          >
            Form View
          </button>

          <button
            className={`abc123-view-btn ${viewMode === "split" ? "active" : ""}`}
            onClick={() => setViewMode("split")}
          >
            Split View
          </button>
        </div>
        {/*  END: ADDED VIEW MODE BUTTONS  */}

        <button
          className="abc123-reviewereevaluate-backbtn"
          onClick={() => navigate("/reviewer/pipelines/applicant")}
        >
          <BiArrowBack size={14} style={{ marginRight: "4px" }} />
          Back to Dashboard
        </button>
      </div>

      {/*  MAIN SECTION WITH VIEW MODE  */}
      <div className={`abc123-reviewereevaluate-container view-${viewMode}`}>

        {/* LEFT PANEL – PDF (Hide if Form-only view) */}
        {viewMode !== "form" && (
          // <div className="abc123-reviewereevaluate-left">
          <div
  className="abc123-reviewereevaluate-left"
  style={
    viewMode === "split" && window.innerWidth >= 1281
      ? { flexBasis: `${leftWidth}%` }
      : {}
  }
>
            <h3 className="abc123-reviewereevaluate-section-title">
              Review Document
            </h3>

            {wrappedPdfUrl ? (
              <>
                <iframe
                  src={wrappedPdfUrl}
                  className="abc123-reviewereevaluate-pdf"
                  title="Applicant Document"
                />
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="abc123-reviewereevaluate-opennew"
                >
                  Open PDF in new tab
                </a>
              </>
            ) : (
              <p className="abc123-reviewereevaluate-nodoc">
                No document uploaded.
              </p>
            )}
          </div>
        )}
    {/* RESIZE DIVIDER — THIS WAS MISSING */}
    {viewMode === "split" && window.innerWidth >= 1281 && (
      <div
        className="abc123-resize-divider"
        onMouseDown={startResizing}
      ></div>
    )}
        {/* RIGHT PANEL – FORM (Hide if PDF-only view) */}
        {viewMode !== "pdf" && (
          <div
  className="abc123-reviewereevaluate-right"
  style={
    viewMode === "split" && window.innerWidth >= 1281
      ? { flexBasis: `${100 - leftWidth}%` }
      : {}
  }
>
          {/* // <div className="abc123-reviewereevaluate-right"> */}
          
            <h3 className="abc123-reviewereevaluate-section-title">
              Evaluate Application
            </h3>

            <ReviewerEvaluationForm
              onSubmit={handleEvaluationSubmit}
              defaultReviewerName={reviewerInfo.name}
              defaultReviewerEmail={reviewerInfo.email}
              defaultApplicantName={applicantInfo.name}
              defaultApplicantEmail={applicantInfo.email}
              reviewFormId={reviewFormId}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ReviewerEvaluate;
